<template>
  <div class="card-loader-container">
    <vue-content-loading :width="300" :height="280">
      <rect x="0" y="0" rx="3" ry="3" width="300" height="170"></rect>
      <rect x="0" y="180" rx="2" ry="2" width="250" height="20"></rect>
      <rect x="0" y="220" rx="2" ry="2" width="150" height="10"></rect>
      <rect x="0" y="240" rx="2" ry="2" width="200" height="10"></rect>
    </vue-content-loading>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading';

export default {
  name: 'CardLoader',
  components: {
    VueContentLoading,
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.card-loader-container {
}
</style>



// WEBPACK FOOTER //
// src/components/common/CardLoader.vue